// extracted by mini-css-extract-plugin
module.exports = {"address":"_2yXpWb7f","manual":"_3qm4FUAX","pureG":"_3ZnZIbxh","pureU1":"_3b11Zke2","pureULg23":"PpvukkJf","pureULg13":"_1qH1iOfP"};